var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.localDefinition
    ? _c(
        "v-col",
        { staticClass: "left-border", attrs: { cols: "4" } },
        [
          _c(
            "v-form",
            { ref: "adForm" },
            [
              _vm.localDefinition
                ? _c(
                    "v-row",
                    { staticClass: "heading-4" },
                    [
                      _c("v-col", { attrs: { cols: "12" } }, [
                        _c("div", [
                          _vm._v(
                            " " +
                              _vm._s(_vm.localDefinition.name) +
                              " Properties "
                          ),
                        ]),
                      ]),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.localDefinition
                ? _c(
                    "v-row",
                    { staticClass: "body-2" },
                    [
                      _c(
                        "v-col",
                        { attrs: { cols: "12" } },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "text-left float-left",
                              attrs: { "align-self": "center" },
                            },
                            [_vm._v("Display To User")]
                          ),
                          _c("v-checkbox", {
                            staticClass: "text-right float-right mt-0 mb-n5",
                            attrs: { "align-self": "center", disabled: true },
                            model: {
                              value: _vm.localDefinition.displayToUser,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.localDefinition,
                                  "displayToUser",
                                  $$v
                                )
                              },
                              expression: "localDefinition.displayToUser",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        { attrs: { cols: "12" } },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "text-left float-left",
                              attrs: { "align-self": "center" },
                            },
                            [_vm._v("Is Replayable")]
                          ),
                          _c("v-checkbox", {
                            staticClass: "text-right float-right mt-0 mb-n5",
                            attrs: { "align-self": "center", disabled: true },
                            model: {
                              value: _vm.localDefinition.isReplayable,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.localDefinition,
                                  "isReplayable",
                                  $$v
                                )
                              },
                              expression: "localDefinition.isReplayable",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        { attrs: { cols: "12" } },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "text-left float-left",
                              attrs: { "align-self": "center" },
                            },
                            [_vm._v("Events Replayable")]
                          ),
                          _c("v-checkbox", {
                            staticClass: "text-right float-right mt-0 mb-n5",
                            attrs: { "align-self": "center", disabled: true },
                            model: {
                              value: _vm.localDefinition.eventsReplayable,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.localDefinition,
                                  "eventsReplayable",
                                  $$v
                                )
                              },
                              expression: "localDefinition.eventsReplayable",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        { attrs: { cols: "12" } },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "text-left float-left",
                              attrs: { "align-self": "center" },
                            },
                            [_vm._v("Auto Replay")]
                          ),
                          _c("v-checkbox", {
                            staticClass: "text-right float-right mt-0 mb-n5",
                            attrs: { "align-self": "center", disabled: true },
                            model: {
                              value: _vm.localDefinition.autoReplay,
                              callback: function ($$v) {
                                _vm.$set(_vm.localDefinition, "autoReplay", $$v)
                              },
                              expression: "localDefinition.autoReplay",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm.localDefinition.maxAutoReplayAttempts && !_vm.editor
                        ? _c("v-col", { attrs: { cols: "12" } }, [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "text-left float-left d-inline-block",
                                attrs: { "align-self": "center" },
                              },
                              [_vm._v("Max Replay Attempts")]
                            ),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "text-right float-right mt-0 mb-n5 mr-3 d-inline-block",
                                attrs: { "align-self": "center" },
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.localDefinition.maxAutoReplayAttempts
                                    ) +
                                    " "
                                ),
                              ]
                            ),
                          ])
                        : _vm._e(),
                      _vm.localDefinition.autoReplayTimeout && !_vm.editor
                        ? _c("v-col", { attrs: { cols: "12" } }, [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "text-left float-left d-inline-block",
                                attrs: { "align-self": "center" },
                              },
                              [_vm._v("Replay Timeout(s)")]
                            ),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "text-right float-right mt-0 mb-n5 mr-3 d-inline-block",
                                attrs: { "align-self": "center" },
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.localDefinition.autoReplayTimeout
                                    ) +
                                    " "
                                ),
                              ]
                            ),
                          ])
                        : _c("v-col", { attrs: { cols: "12" } }, [
                            _c(
                              "div",
                              {
                                staticClass: "text-left float-left",
                                attrs: { "align-self": "center" },
                              },
                              [_vm._v("Activity Definition Type")]
                            ),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "text-right float-right mt-0 mb-n5 mr-3",
                                attrs: {
                                  "align-self": "center",
                                  disabled: true,
                                },
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.getActivityDefinitionType(
                                        _vm.localDefinition
                                          .activityDefinitionTypeId
                                      )
                                    ) +
                                    " "
                                ),
                              ]
                            ),
                          ]),
                      _vm.localDefinition.assemblyName && !_vm.editor
                        ? _c("v-col", { attrs: { cols: "12" } }, [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "text-left float-left d-inline-block",
                                attrs: { "align-self": "center" },
                              },
                              [_vm._v("Assembly Name")]
                            ),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "text-right float-right mt-0 mb-n5 mr-3 d-inline-block",
                                attrs: { "align-self": "center" },
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.localDefinition.assemblyName) +
                                    " "
                                ),
                              ]
                            ),
                          ])
                        : _vm._e(),
                      _vm.localDefinition.dependencyMap && !_vm.editor
                        ? _c("v-col", { attrs: { cols: "12" } }, [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "text-left float-left d-inline-block pa-0",
                                attrs: { "align-self": "center" },
                              },
                              [_vm._v("Dependency Map")]
                            ),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "text-right float-right mt-0 d-inline-block col-6 pa-0 text-truncate mr-3 ml-n3",
                                attrs: {
                                  "align-self": "center",
                                  title: _vm.localDefinition.dependencyMap,
                                },
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.localDefinition.dependencyMap) +
                                    " "
                                ),
                              ]
                            ),
                          ])
                        : _vm._e(),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.localDefinition
                ? _c(
                    "v-row",
                    { staticClass: "body-2" },
                    [
                      _vm.localDefinition.orchestrationRouteModel !== undefined
                        ? _c("v-col", { attrs: { cols: "12" } }, [
                            _c(
                              "div",
                              {
                                staticClass: "text-left float-left",
                                class: "col-6  pa-0 d-inline-block",
                                attrs: { "align-self": "center" },
                              },
                              [_vm._v(" Orchestration Route ")]
                            ),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "text-right float-left mt-0 d-inline-block col-6 pa-0 text-truncate mr-3 ml-n3",
                                attrs: {
                                  "align-self": "center",
                                  disabled: true,
                                },
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.localDefinition
                                        .orchestrationRouteModel === undefined
                                        ? "N/A"
                                        : ""
                                    ) +
                                    " "
                                ),
                              ]
                            ),
                            _vm.localDefinition.orchestrationRouteModel !==
                            undefined
                              ? _c("div", { staticClass: "col-12 pa-0 ma-0" }, [
                                  _vm.localDefinition.orchestrationRouteModel
                                    .pipelineJobTypeName
                                    ? _c(
                                        "div",
                                        {
                                          staticClass:
                                            "col-12 d-inline-block body-2 font-weight-medium py-0",
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.localDefinition
                                                  .orchestrationRouteModel
                                                  .pipelineJobTypeName
                                              ) +
                                              " "
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm.localDefinition.orchestrationRouteModel
                                    .queueName
                                    ? _c(
                                        "div",
                                        {
                                          staticClass:
                                            "col-12 d-inline-block ml-2 body-2 text-truncate py-0",
                                          attrs: {
                                            title:
                                              _vm.localDefinition
                                                .orchestrationRouteModel
                                                .queueName,
                                          },
                                        },
                                        [
                                          _vm._v(
                                            " Queue Name: " +
                                              _vm._s(
                                                _vm.localDefinition
                                                  .orchestrationRouteModel
                                                  .queueName
                                              ) +
                                              " "
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm.localDefinition.orchestrationRouteModel
                                    .routeTypeName
                                    ? _c(
                                        "div",
                                        {
                                          staticClass:
                                            "col-12 d-inline-block ml-2 body-2 text-truncate py-0",
                                          attrs: {
                                            title:
                                              _vm.localDefinition
                                                .orchestrationRouteModel
                                                .routeTypeName,
                                          },
                                        },
                                        [
                                          _vm._v(
                                            " Route Type: " +
                                              _vm._s(
                                                _vm.localDefinition
                                                  .orchestrationRouteModel
                                                  .routeTypeName
                                              ) +
                                              " "
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm.localDefinition.orchestrationRouteModel
                                    .routeSettings
                                    ? _c(
                                        "div",
                                        {
                                          staticClass:
                                            "col-12 d-inline-block ml-2 body-2 text-truncate py-0",
                                          attrs: {
                                            title:
                                              _vm.localDefinition
                                                .orchestrationRouteModel
                                                .routeSettings,
                                          },
                                        },
                                        [
                                          _vm._v(
                                            " Route Settings: " +
                                              _vm._s(
                                                _vm.localDefinition
                                                  .orchestrationRouteModel
                                                  .routeSettings
                                              ) +
                                              " "
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm.localDefinition.orchestrationRouteModel
                                    .updateDate &&
                                  _vm.localDefinition.orchestrationRouteModel
                                    .routeTypeId === 1
                                    ? _c(
                                        "div",
                                        {
                                          staticClass:
                                            "col-12 d-inline-block ml-2 body-2 text-truncate py-0",
                                          attrs: {
                                            title:
                                              _vm.localDefinition
                                                .orchestrationRouteModel
                                                .updateDate,
                                          },
                                        },
                                        [
                                          _vm._v(
                                            " Update Date: " +
                                              _vm._s(
                                                new Date(
                                                  _vm.localDefinition.orchestrationRouteModel.updateDate
                                                ).toLocaleDateString() +
                                                  " " +
                                                  new Date(
                                                    _vm.localDefinition
                                                      .orchestrationRouteModel
                                                      .updateDate + "Z"
                                                  ).toLocaleTimeString()
                                              ) +
                                              " "
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ])
                              : _vm._e(),
                          ])
                        : _vm._e(),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }